import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Organizations = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
    { key: 'gstin', label: 'GSTIN' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'ORG001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Organization Name' },
    { name: 'address', label: 'Address', type: 'textarea', fullWidth: true },
    { name: 'city', label: 'City', placeholder: 'City' },
    { name: 'state', label: 'State', placeholder: 'State' },
    { name: 'country', label: 'Country', placeholder: 'Country' },
    { name: 'pincode', label: 'Pincode', placeholder: 'Pincode' },
    { name: 'phone', label: 'Phone', placeholder: 'Phone Number' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'email@company.com' },
    { name: 'gstin', label: 'GSTIN', placeholder: 'GSTIN Number' },
    { name: 'pan', label: 'PAN', placeholder: 'PAN Number' },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Organizations"
      endpoint="organizations"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN']}
    />
  );
};

export default Organizations;
